import { render, staticRenderFns } from "./website-saas-head.vue?vue&type=template&id=32d4623b&scoped=true"
import script from "./website-saas-head.vue?vue&type=script&lang=js"
export * from "./website-saas-head.vue?vue&type=script&lang=js"
import style0 from "./website-saas-head.vue?vue&type=style&index=0&id=32d4623b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4623b",
  null
  
)

export default component.exports